export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5181.bf9f429f.jpg";